// test153
(153 && 0);
